export const GET_BUSINESSES_DELAY_TIME = 500;

export const DOWNLOAD_REPORT_ID = 'download-report-icon-button';
